<template>
  <div class="order__price-block" @click="showProductModal(product)">
    <div class="order__price-new">{{ product.min_options_price }}</div>
    <div class="order__button-plus">
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M6 12H18M12 6V18" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
  </div>

</template>

<script>
import TheModal from "@/components/TheModal.vue";
import {mapMutations} from "vuex";

export default {
  name: 'TheProductSelectButton',
  components: {TheModal},
  methods:{
    ...mapMutations({
      'showProductModal': 'productModal/showProductModal',
    }),
  },
  props: {
    product: {
      type: Object,
      require: true,
    },
    cart: {
      type: Object,
      default: null,
      require: false,
    }
  }
}
</script>

